import { cookie } from '@tencent/qd-lib';
export const ROBOT_ID = 'call_robot_id';
export const ROBOT_ID_KEY_4_PHP = 'robotId';
export const KF_ROBOT_ID = 'robot_id'; // for“企点客服套餐”机器人id的cookie key
export const ROBOT_ID_KEY_4_COMMON = 'zhiku_robot_id'; // for“其他非zhiku、非电话call子站使用的、通用的”机器人id的cookie key（PS：需要种在根path下，其他子站都可用）

/**
 * 种机器人id cookie
 * @param {String} val 要设置的cookie值
 */
/**
 * 取机器人id cookie
 * @return {String} 机器人id
 */
export const isSsc = cookie.get('qd_robot_is_ssc') == '1';
export function getRobotIdFromCookie() {
    return cookie.get(KF_ROBOT_ID);
}
